import React, { useState } from "react";
import Header from "../../components/Header";
import {useRecoilValue} from "recoil";
import {fetchAPIResponseSelector} from "../../store/user.atom";
import {toast} from "react-toastify";

const Notifications: React.FC = () => { 

    const [title, setTitle] = useState<any>();
    const [description, setDescription] = useState<any>();

    const fetchAPIResponse = useRecoilValue(fetchAPIResponseSelector);

    const handleSendNotications = async () => {
        try {
            let fetchUrl = `/admins/notification`;

            const response = await fetchAPIResponse(fetchUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },
                body: JSON.stringify({
                    title,
                    message: description
                })
            });

            if(response.code === 200) {
                toast.success("Successfully sent notification")
            } else {
                toast.error("Error whilst sending notification")
            }
        } catch (error) {
            toast.error("Error whilst sending notification: " + error)
        }
    }

    return ( 
        <div className='flex flex-col items-center w-full h-full overflow-auto py-10 gap-6'>
            <Header title={'Notifications'} button={false} buttonTitle={''} action={''} />
            <div className="zbh-card w-11/12 p-8">
                <h2 className="font-display text-base font-semibold text-ink">Push a notification</h2>
                <p className="mt-1 text-sm text-categoriesTextColor">Sends to every customer with the app installed and notifications enabled.</p>
                <div className="mt-5 space-y-4">
                    <div>
                        <label className="zbh-label">Title</label>
                        <input
                            type="text"
                            placeholder="e.g. Weekend combo deal 🍔"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            className="zbh-input"
                        />
                    </div>
                    <div>
                        <label className="zbh-label">Message</label>
                        <textarea
                            placeholder="What do you want customers to know?"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            rows={3}
                            className="zbh-input resize-none"
                        />
                    </div>
                    <button onClick={handleSendNotications} className="zbh-btn-accent">
                        <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
                          <path d="M22 2 11 13" /><path d="M22 2 15 22l-4-9-9-4 20-7Z" />
                        </svg>
                        Send notification
                    </button>
                </div>
            </div>
        </div>
    )
}

export default Notifications;